"use client";
import { useEffect, useState } from "react";

import * as microsoftTeams from "@microsoft/teams-js";

declare global {
  interface Window {
    microsoftTeams?: any;
  }
}
import Header from "./components/Header";
import ServiceAlert from "./components/ServiceAlert";
import NewRequest from "./components/NewRequest";
import CommonRequest from "./components/CommonRequest";
import Feedback from "./components/Feedback";
import ContactUs from "./components/ContactUs";
import { useAuth } from "./hooks/useAuth";

export default function Home() {
  const [accessToken, setAccessToken] = useState<string | null>(null);
  const { getAccessToken, isAuthenticating, isInitialized, authError } =
    useAuth();

  const isTeams =
    typeof window !== "undefined" &&
    window.parent !== window &&
    typeof microsoftTeams !== "undefined";

  useEffect(() => {
    console.log("isTeams: ", isTeams);
    if (isAuthenticating || !isInitialized || accessToken || isTeams) return; // Prevent fetching if still authenticating or already have token
    const fetchAccessToken = async () => {
      try {
        const token = await getAccessToken();
        if (token) {
          console.log("Access token acquired");
          setAccessToken(token);
        } else {
          console.error("Access token is null or undefined");
        }
      } catch (error) {
        console.error("Error fetching alerts:", error);
      }
    };

    fetchAccessToken();
  }, [isAuthenticating, isInitialized, accessToken, getAccessToken]);

  // Initialize Teams SDK for Teams context support (no authentication logic)
  useEffect(() => {
    const isTeams =
      typeof window !== "undefined" &&
      window.parent !== window &&
      typeof microsoftTeams !== "undefined";

    if (isTeams) {
      const getAuthToken = async () => {
        try {
          await microsoftTeams.app.initialize();
          const token = await microsoftTeams.authentication.getAuthToken();
          console.log("Token acquired:", token);
          setAccessToken(token);
        } catch (error) {
          console.error("Failed to get token:", error);
        }
      };
      getAuthToken();
    }
  }, []);

  if (
    (!accessToken && !isTeams) ||
    (!accessToken && isTeams && (isAuthenticating || !isInitialized))
  ) {
    // Show loading indicator only after token is acquired
    return (
      <div
        style={{
          textAlign: "center",
          marginTop: "40vh",
        }}
      >
        <div
          style={{
            display: "inline-block",
            width: "48px",
            height: "48px",
            border: "6px solid #ccc",
            borderTop: "6px solid #222",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
          }}
        />
        <style>
          {`
          @keyframes spin {
            0% { transform: rotate(0deg);}
            100% { transform: rotate(360deg);}
          }
        `}
        </style>
      </div>
    );
  }

  if (!accessToken) {
    // Show error if authentication failed and provide Teams login button
    let popupBlockerMsg = null;
    if (authError && authError.toLowerCase().includes("popup")) {
      popupBlockerMsg = (
        <div style={{ color: "red", marginTop: 8 }}>
          It looks like a popup was blocked. Please allow popups for this site
          in Teams desktop and try again.
        </div>
      );
    }
  }

  return (
    <div className="min-h-screen bg-white font-sans text-white">
      <div className="z-10 items-center bg-black text-sm lg:flex">
        <Header />
      </div>
      <div>{accessToken && <ServiceAlert accessToken={accessToken} />}</div>
      <div>
        <br />
        <NewRequest />
      </div>
      <br />
      <div>
        <CommonRequest />
      </div>
      <div className="flex flex-row flex-wrap justify-center items-center text-center text-gray-800">
        <Feedback />
        <div className="text-black items-stretch text-base -mx-4">|</div>
        <ContactUs />
      </div>
      <footer className="dark:bg-gray-800 fixed bottom-0 w-full">
        <div className="w-full mx-auto text-center p-4 bg-white">
          <br />
          <span className="text-sm text-gray-500">
            <span>All content © 2026 Golub Capital.</span> All Rights Reserved.
          </span>
        </div>
      </footer>
      <br />
      <br />
    </div>
  );
}
